// import swiper package
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
Swiper.use([Navigation, Pagination]);

namespace NKU.imageCarousel {
	export const init = () => {
		let imageCarousels = document.querySelectorAll('.js-image-carousel');

		imageCarousels.forEach((imageCarousel, index) => {
			let swiperContainer = imageCarousel.querySelector('.swiper') as HTMLElement;
			let swiperPrev = imageCarousel.querySelector('.js-previous');
			let swiperNext = imageCarousel.querySelector('.js-next');
			let swiperPagination = imageCarousel.querySelector('.js-pagination');
			const carouselType = imageCarousel.getAttribute('data-carouselType') || '3up';
			const is1Up = carouselType === '1up';
			const current = imageCarousel.querySelector('.js-current-slide');
			const total = imageCarousel.querySelector('.js-total-slides');

			// setup our indexes to handle multiple swipers on a page
			swiperContainer.classList.add(`image-carousel-swiper-${index}`);
			swiperPrev.classList.add(`image-carousel-prev-${index}`);
			swiperNext.classList.add(`image-carousel-next-${index}`);
			swiperPagination.classList.add(`image-carousel-pagination-${index}`);

			// Update slide count function
			const updateSlideCount = (swiper: Swiper) => {
				if (current && total) {
					current.textContent = `${swiper.realIndex + 1}`;
					total.textContent = `${swiper.slides.length}`;
				}
			};

            let totalSlides = swiperContainer.querySelectorAll('.swiper-slide').length;
            let enableLoop = totalSlides >= 4;

			let swiper = new Swiper(`.image-carousel-swiper-${index}`, {
				slidesPerView: 1,
				effect: 'slide',
				loop: enableLoop,
                centeredSlides: is1Up ? true : false,
				navigation: {
					nextEl: `.image-carousel-next-${index}`,
					prevEl: `.image-carousel-prev-${index}`,
				},
				pagination: {
					el: `.image-carousel-pagination-${index}`,
					clickable: true,
				},
				breakpoints: {
					// Responsive breakpoints
					0: {
						spaceBetween: 30,
						slidesPerView: 1,
					},
					768: {
						spaceBetween: 30,
						slidesPerView: is1Up ? 1.75 : 2,
					},
					992: {
						spaceBetween: 30,
						slidesPerView: is1Up ? 2 : 3,
					},
				},
				on: {
					init: function () {
						updateSlideCount(this);
					},
					slideChangeTransitionEnd: function () {
						updateSlideCount(this);
					},
				},
			});
		});
	};
}

document.addEventListener('DOMContentLoaded', () => {
	NKU.imageCarousel.init();
});
